import React, { useState } from "react";
import { Input, Button } from 'reactstrap';
import { useHistory, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Onboarding = ({setUser, isOnboarding}) => {
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [wallet, setWallet] = useState('');
  const [twitter, setTwitter] = useState(null);
  const [instagram, setInstagram] = useState(null);
  const [facebook, setFacebook] = useState(null);
  const [youtube, setYoutube] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { getIdTokenClaims, user: auser } = useAuth0();

  function handleStep1() {
    if(name.length === 0) return false;
    setError(false);
    setStep(2);
  }

  async function handleStep2() {
    if(username.length === 0) return false;
    setLoading(true);
    const valid = await checkUsername();
    setLoading(false);
    if(valid) {
      setError(false);
      setStep(3);
    } else {
      setError(true);
    } 
  }

  async function handleStep3(e) {
    e.preventDefault();
    setStep(4);
  }
  
  async function handleStep4(e) {
    e.preventDefault();
    setLoading(true);
    await createUser();
    setLoading(false);
    history.push('/');
  }

  async function checkUsername() {
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/checkuser/${username}`, {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method:'GET'
    });
    const user = await response.json();
    return user.valid;
  }

  async function createUser() {
    const token = await getIdTokenClaims();
    const sub = auser.sub.split('|')[1];
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.__raw}`
      },
      body: JSON.stringify({
        sub,
        name,
        username,
        avatar: '👾',
        links: getSocialLinks(),
        wallet
      }),
    });
    const data = await response.json();
    setUser(data);
  }

  function getSocialLinks() {
    const socialLinks = [];
    if(twitter) socialLinks.push({name: 'Twitter', url: twitter});
    if(instagram) socialLinks.push({name: 'Instagram', url: instagram});
    if(facebook) socialLinks.push({name: 'Facebook', url: facebook});
    if(youtube) socialLinks.push({name: 'Youtube', url: youtube});
    return socialLinks;
  }

  if(!isOnboarding) {
    return <Redirect to="/" />;
  }

  return (
    <div className="onboarding">
      <div style={{fontSize:'80px',cursor:'default'}}>🦊</div>
      {step === 1 &&
        <div className="step1">
          <h4>Let's start by choosing your <b>Name</b>. Ready?</h4>
          <div className="form">
            <Input type="text" placeholder="Enter your name" onChange={(e) => setName(e.target.value)} />
            <Button className="btn-primary" onClick={handleStep1}>Let's Go</Button>
          </div>
        </div>
      }
      {step === 2 &&
        <div className="step2">
          <h4>Great! Now choose your <b>Username</b>. Be creative!</h4>
          <div className="form">
            <Input type="text" placeholder="Enter your Username" onChange={(e) => {setError(false);setUsername(e.target.value);}} />
            {error && <small className="error">Username taken or invalid, please try again.</small>}
            <Button disabled={loading} className="btn-primary" onClick={handleStep2}>{loading && <FontAwesomeIcon icon="spinner" className="fa-spin" />}Let's Go</Button>
          </div>
        </div>
      }
      {step === 3 &&
        <div className="step3">
          <h4>Setup your wallet. Okay?</h4>
          <a className="ref-link" href="https://metamask.io/download.html" target="_blank">Don't have a wallet? Check out MetaMask.</a>
          <div className="form">
            <Input type="text" placeholder="ETH Wallet Address (ERC-20)" onChange={(e) => setWallet(e.target.value.trim())} />
            <Button className="btn-primary" onClick={handleStep3}>Let's Go</Button>
            <br /><br />
            <a href="#" onClick={e => handleStep3(e, true)}>Skip for now, setup later.</a>
          </div>
        </div>
      }
      {step === 4 &&
        <div className="step3">
          <h4>Enter your social links</h4>
          <div className="form">
            <Input type="text" placeholder="Twitter" onChange={(e) => setTwitter(e.target.value)} />
            <Input type="text" placeholder="Instagram" onChange={(e) => setInstagram(e.target.value)} />
            <Input type="text" placeholder="Facebook" onChange={(e) => setFacebook(e.target.value)} />            
            <Input type="text" placeholder="Youtube" onChange={(e) => setYoutube(e.target.value)} />
            <Button disabled={loading} className="btn-primary" onClick={handleStep4}>{loading && <FontAwesomeIcon icon="spinner" className="fa-spin" />}Let's Go</Button>
            <br /><br />
            <a href="#"onClick={e => handleStep4(e, true)}>Skip for now, setup later.</a>
          </div>
        </div>
      }
    </div>
  )
};

export default Onboarding;
